module.exports = __webpack_public_path__ + "media/images/WFC_Landscape_White-db9575df7704fb8d25c8c43661a9b029.svg";